import { Box, Grid, Typography } from "@mui/material";
import { Labeled, useNotify, useRecordContext } from "react-admin";
import { getFile } from "server/components/DownloadFile";
import { DoctorantCandidacyStatus } from "utils/constants";
import DoctoralDateField from "../../Partials/DoctoralDateField";

const ObjectionSection = () => {
  const record = useRecordContext();
  const notify = useNotify();

  if (!record) return null;

  const isNotAdmitted = record.status === DoctorantCandidacyStatus.NotAdmitted;
  const isObjectionReview = record.status === DoctorantCandidacyStatus.ObjectionUnderReview;

  if (!isNotAdmitted && !isObjectionReview && !record.objectionDocumentId) {
    return <em>Няма данни</em>;
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <Labeled label="Недопуснат на">
          <DoctoralDateField source="notAdmittedOn" showTime emptyText="—" />
        </Labeled>
      </Grid>

      {isNotAdmitted && (
        <Grid item xs={12} md={3}>
          <Labeled label="Срок за възражение">
            <DoctoralDateField source="objectionDeadline" emptyText="—" />
          </Labeled>
        </Grid>
      )}

      {record.objectionSubmittedOn && (
        <Grid item xs={12} md={3}>
          <Labeled label="Възражение подадено на">
            <DoctoralDateField source="objectionSubmittedOn" showTime emptyText="—" />
          </Labeled>
        </Grid>
      )}

      <Grid item xs={12} md={3}>
        <Labeled label="Документ с възражение">
          {record.objectionDocumentId ? (
            <Typography
              sx={{ textDecoration: "underline", fontSize: "14px", cursor: "pointer" }}
              onClick={() => getFile(record.objectionDocumentId, notify, "private")}
            >
              {`file-${record.objectionDocumentId}`}
            </Typography>
          ) : (
            <Box component="span">—</Box>
          )}
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default ObjectionSection;
